import {Component} from "react";
import {Button, Pagination} from "antd";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as setAnswer from "../actions/evaluation";
import * as actions from '../actions/evaluation';
import React from "react";
import {historyPush, request} from "../utils/Util";
import './Ranking.css'

class Ranking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            f: 0,
            count: 0,
            page: 1,
            pageSize:8,
            sectionName: ''
        }

    }




    _handlerNextQuestion = (action)=>{
        this._doSetAnswer(action);
    }

    handelChange(page, pageSize){
        console.log(page, pageSize);
        this.getData(page);
    }
    handelSectionClick(sectionName){
        this.setState({sectionName: sectionName, page:1});
        this.getData(1, sectionName);
    }

    async getData(page, sectionName){
        const {actions,match} = this.props;
        var reqData = {test_id:match.params.id,pages:page};
        if(this.state.sectionName){
            reqData = {...reqData, 'section_name':this.state.sectionName};
        }
        if(sectionName){
            reqData["section_name"] = sectionName;
        }
        const questions = await request(`/questionnaires/test_record/`,'get',reqData);
        actions.setAnalysisEvaluation(questions.detail);
        // actions.setCurrentEvaluation({page: 0});
        this.setState({count:questions.detail.count,    test_num: questions.detail.test_num, page:page})
        console.log(questions);
    }


    _doSetAnswer(action) {

    }

    componentDidMount() {
        this.getData(1);
    }


    render() {

        const {evaluation,currentEvaluation,actions, match} = this.props;
        console.log(this.props,'排行')

        return (
            <div className='rankBox'>
                <div className='title'>错题排行：</div>
                <div className='sub_title'>共<span>{this.state.count}</span>题，共<span>{this.state.test_num}</span>人参与</div>
                <div style={{marginTop:20}}>

                    <Button onClick={this.handelSectionClick.bind(this,'english')}>English</Button>
                    <Button onClick={this.handelSectionClick.bind(this,'reading')}>Reading</Button>
                    <Button onClick={this.handelSectionClick.bind(this,'math')}>Math</Button>
                    <Button onClick={this.handelSectionClick.bind(this,'science')}>Science</Button>

                </div>
                <ul className='list'>
                    <li><span>题号</span><div style={{background:'none'}}></div><span style={{color: 'rgba(0,0,0,.5)'}}>错题人数</span></li>
                    {
                        evaluation.datas && evaluation.datas.map((item,index)=>{
                            var f_nummber = parseInt(Object.keys(Object.values(evaluation.datas[0])[0])[0]);
                            if(index === 0 && this.state.page === 1){
                                this.state.f = f_nummber;
                            }
                            var err_number = parseInt(Object.keys(Object.values(item)[0])[0]);
                            // var number = Object.keys(item);
                            var number = Object.values(Object.values(item)[0])[0].number;
                            var title = Object.values(Object.values(item)[0])[0].title;
                            var w = err_number / f_nummber * 400 + 'px';
                            return (
                                <li onClick={()=>{
                                    actions.setCurrentEvaluation({page: index, test_id:match.params.id, 'curWrongPage':this.state.page, 'totalPage':parseInt(this.state.count/this.state.pageSize)+1});
                                    historyPush(`/viewResult/wrong/`);
                                }}><span>{title}&nbsp;&nbsp;{number}</span><div style={{width: w}}></div><span>{err_number}</span></li>
                            )
                        })
                    }
                </ul>
                <Pagination pageSize={this.state.pageSize} current={this.state.page} onChange={this.handelChange.bind(this)} defaultCurrent={1} total={this.state.count} />
            </div>
        );
    }
}
Ranking = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))( Ranking);

export default Ranking;